/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSessionHandoffRequestBody,
  CreateSessionHandoffRequestBody$Outbound,
  CreateSessionHandoffRequestBody$outboundSchema,
} from "../components/createsessionhandoffrequestbody.js";

export type CreateAgentSessionHandoffSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateAgentSessionHandoffRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Hardware serial number of the machine minting the link, when the agent can read it.
   */
  gramDeviceSerial?: string | undefined;
  /**
   * Hostname of the machine minting the link, when the agent can read it.
   */
  gramDeviceHostname?: string | undefined;
  createSessionHandoffRequestBody: CreateSessionHandoffRequestBody;
};

/** @internal */
export type CreateAgentSessionHandoffSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateAgentSessionHandoffSecurity$outboundSchema: z.ZodMiniType<
  CreateAgentSessionHandoffSecurity$Outbound,
  CreateAgentSessionHandoffSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function createAgentSessionHandoffSecurityToJSON(
  createAgentSessionHandoffSecurity: CreateAgentSessionHandoffSecurity,
): string {
  return JSON.stringify(
    CreateAgentSessionHandoffSecurity$outboundSchema.parse(
      createAgentSessionHandoffSecurity,
    ),
  );
}

/** @internal */
export type CreateAgentSessionHandoffRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Device-Serial"?: string | undefined;
  "Gram-Device-Hostname"?: string | undefined;
  CreateSessionHandoffRequestBody: CreateSessionHandoffRequestBody$Outbound;
};

/** @internal */
export const CreateAgentSessionHandoffRequest$outboundSchema: z.ZodMiniType<
  CreateAgentSessionHandoffRequest$Outbound,
  CreateAgentSessionHandoffRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramDeviceSerial: z.optional(z.string()),
    gramDeviceHostname: z.optional(z.string()),
    createSessionHandoffRequestBody:
      CreateSessionHandoffRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramDeviceSerial: "Gram-Device-Serial",
      gramDeviceHostname: "Gram-Device-Hostname",
      createSessionHandoffRequestBody: "CreateSessionHandoffRequestBody",
    });
  }),
);

export function createAgentSessionHandoffRequestToJSON(
  createAgentSessionHandoffRequest: CreateAgentSessionHandoffRequest,
): string {
  return JSON.stringify(
    CreateAgentSessionHandoffRequest$outboundSchema.parse(
      createAgentSessionHandoffRequest,
    ),
  );
}
